import type { IqeProject, TestRun } from '../interfaces/ui';

export type TestExecutionActionKey =
  | 'GENERATE'
  | 'RUN'
  | 'ENHANCE'
  | 'VIEW_CURRENT_GENERATION';

export interface TestExecutionActionOption {
  key: TestExecutionActionKey;
  label: string;
}

export interface ProjectExecutionActionState {
  displayVersion: TestRun | null;
  hasLastRunData: boolean;
  options: TestExecutionActionOption[];
}

export const READY_STATE_ACTIONS: TestExecutionActionOption[] = [
  {
    key: 'GENERATE',
    label: 'Generate and execute Test plan',
  },
];

export const LAST_RUN_ACTIONS: TestExecutionActionOption[] = [
  {
    key: 'RUN',
    label: 'Execute Automation Suite',
  },
  {
    key: 'ENHANCE',
    label: 'Enhance and Execute test plan',
  },
];

export function getProjectExecutionActionState(
  runs: TestRun[] | undefined,
  isExecutionInProgress: boolean,
): ProjectExecutionActionState {
  const [latestRun, previousRun] = runs || [];

  const displayVersion =
    (isExecutionInProgress ? previousRun : latestRun) ?? null;

  const hasLastRunData = Boolean(latestRun);

  return {
    displayVersion,
    hasLastRunData,
    options: hasLastRunData ? LAST_RUN_ACTIONS : READY_STATE_ACTIONS,
  };
}
